
export class EventModel {
    EventID: number = 0;
    IsActive: boolean = false;
    EventCode: string|undefined = undefined;
    EventDescription: string = "";
    Location:string = "";
    EventTypeID: string|undefined = undefined;
    CampaignYear: number = 0;
    RevToDate: number = 0;
    CreatedBy: number = 0;
    Count: number = 0;
    StartDate: Date|undefined = undefined;
    EndDate: Date|undefined = undefined;
    EventBudget: Date|undefined = undefined;
}